<div [ngClass]="'closeby-item-' + index()" class="closeby">
  <div class="closeby__image">
    <a [routerLink]="careproviderRouterLink()">
      <div class="w-full relative">
        @if (hasImage()) {
          <img [alt]="careProviderToDisplay().name" [ngSrc]="imageUrl()" height="340" width="500">
        } @else {
          <div class="hsa-photo">
            <app-segment-icon
              [imageSize]="120"
              [segment]="mainSegment()"
            ></app-segment-icon>
          </div>
        }
        <div *ngIf="careProviderToDisplay().rating"
             class="flex rounded-full gap-1 bg-grey-10 justify-center items-center w-fit h-7 px-3 py-2 text-sm text-grey-0 absolute bottom-2 right-2">
          <app-ui-icon
            [name]="'star_filled'"
            [size]="'sm'"
            color="var(--apricot-3)"
          ></app-ui-icon>
          <span>{{ careProviderToDisplay().rating | round: 1 }}</span>
        </div>
      </div>
    </a>
  </div>

  <div class="closeby__details">
    <div class="closeby__name">
      <a [routerLink]="careproviderRouterLink()">{{ careProviderToDisplay().name }}</a>
    </div>

    <div class="closeby__address">
      <span>
        <app-ui-icon
          class="closeby__address__icon"
          color="#067185"
          name="marker"
          size="sm"
        ></app-ui-icon>
      </span>
      @if (careProviderToDisplay().address.visitingAddress === null) {
        <span>{{ careProviderToDisplay().address.street }} {{ careProviderToDisplay().address.zipCode }} {{ careProviderToDisplay().address.city }}</span>
      } @else {
        <span>{{ careProviderToDisplay().address.visitingAddress }}</span>
      }
    </div>

    <div class="closeby__opening-hours">
      <app-openning-hours-small-v2
        [openHours]="careProviderToDisplay().openHours"
      ></app-openning-hours-small-v2>
    </div>
  </div>
</div>
